export function pad(n: number, length: number, z: string = '0') {
  const s = n + '';
  return s.length >= length ? n : new Array(length - s.length + 1).join(z) + n;
}
